import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { useWebSocket } from '../WebSocketContext';
import logger from '../utils/logger.js';

const ProctoringSuccess = () => {
  const navigate = useNavigate();
  const { ws } = useWebSocket();

  // Send success event when component mounts
  useEffect(() => {
    if (ws && ws.readyState === WebSocket.OPEN) {
      const message = {
        type: "client_event",
        message: "proctoring_secondary_device_success",
        timestamp: new Date().toISOString()
      };
      
      logger.info('Sending proctoring success event to server');
      ws.send(JSON.stringify(message));
    }
  }, [ws]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center p-8 max-w-md bg-white rounded-lg shadow-sm">
        <div className="flex justify-center mb-6">
          <CheckCircle size={64} className="text-green-500" />
        </div>
        <h1 className="text-3xl font-bold mb-4">Proctoring Session Ended</h1>
        <p className="text-gray-600 mb-6">
          Your proctoring session has been successfully completed. The interviewer has ended the session.
        </p>
        <div className="bg-blue-50 p-4 rounded-md mb-8">
          <h3 className="text-blue-700 font-medium mb-2">What's Next?</h3>
          <p className="text-blue-600 text-sm">
            You can close this device's browser window. Your interview will continue on your primary device.
          </p>
        </div>
        <div className="flex flex-col space-y-3">
          <button
            onClick={() => navigate('/')}
            className="px-6 py-3 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors font-medium"
          >
            Return to Home Page
          </button>
          <button
            onClick={() => window.close()}
            className="px-6 py-2 text-gray-600 rounded-md hover:bg-gray-100 transition-colors text-sm"
          >
            Close Window
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProctoringSuccess;
